module.exports = __webpack_public_path__ + "img/desert-charger.e41fb466.jpg";